exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-module-page .ck-editor__main .ck.ck-editor__editable_inline{border:0!important;padding-left:0!important}", ""]);

// exports
